//const scripts = ["[src*='boxtal']", "[src*='chatra']", "[src*='salespop']"];
//const scripts = ["script", "meta", "link"];
const nodes = ["#cb-widget-sales-pop", "#criteo-tags-div", "#chatra", "#df-results-template", "#shop-hcaptcha-badge-container", "#preview-bar-iframe", "div.js_mk_sb"];

const validSound = new Audio('//www.atome3d.com/cdn/shop/files/parcel-scan-valid-sound.mp3?v=13901538493749168458');
const errorSound = new Audio('//www.atome3d.com/cdn/shop/files/parcel-scan-error-sound.mp3?v=13562207588538577099');

const carrierData = {
  carrierList: [],
  carrierSelected: undefined,
  sessionId: undefined
};

// clean scripts complements
$(document).on ('DOMNodeInserted', 'meta, script, link, style, iframe', function(e) {
  $(this).remove ().end ().html ();
});

$(document).ready(function() {
  
  // reload page (WIP)
  /*$("#header .logo").on ("click", function () {
    if (!$(".parcels-scan").is(":hidden")) {
      showSessionEnd ();
    }
  });*/

  // clean nodes complements
  nodes.forEach (function(node) {
    $('body').on ('DOMNodeInserted', node, function(e) {
      $(this).remove ();
    });
  });

  // logout method
  $('a[href^="/account/logout"]').on("click", function () {
    $.ajax( $(this).attr('href') ).done (function() {
      window.location.reload ();
    });
    return false;
  });
});

// Disable Back button
(function (global) {

  if(typeof (global) === "undefined") {
	throw new Error("window is undefined");
  }

  var _hash = "!";
  var noBackPlease = function () {
    global.location.href += "#";

    // making sure we have the fruit available for juice....
    // 50 milliseconds for just once do not cost much (^__^)
    global.setTimeout(function () {
      global.location.href += "!";
    }, 50);
  };
	
  // Earlier we had setInerval here....
  global.onhashchange = function () {
    if (global.location.hash !== _hash) {
      global.location.hash = _hash;
      console.log ("changement de page");
    }
  };

  global.onload = function () {
      
    noBackPlease();

    // disables backspace on page except on input fields and textarea..
    document.body.onkeydown = function (e) {
      var elm = e.target.nodeName.toLowerCase();
      if (e.which === 8 && (elm !== 'input' && elm  !== 'textarea')) {
        e.preventDefault();
      }
      // stopping event bubbling up the DOM tree..
      e.stopPropagation();
    };
      
  };

})(window);

// tools
function nullIfEmpty (str) {
  return str.trim().length > 0 ? str : null;
}